import { takeFirstVisit } from "../storage";
import { el } from "./dom";

/* ---------- Help dialog ---------- */
export function initHelp(onOpen: () => void) {
  const helpDlg = el<HTMLDialogElement>("help");
  function open() {
    if (helpDlg.open) return;
    onOpen();
    helpDlg.showModal();
  }
  el("vHelp").addEventListener("click", open);
  el("helpClose").addEventListener("click", () => helpDlg.close());
  helpDlg.addEventListener("click", (e) => {
    if (e.target === helpDlg) helpDlg.close();
  }); // click outside closes

  return {
    open,
    isOpen: () => helpDlg.open,
    /** Shows the help automatically on the very first visit. */
    showOnFirstVisit() {
      if (takeFirstVisit()) open();
    },
  };
}
